import { render, staticRenderFns } from "./KeepAliveView.vue?vue&type=template&id=7a0a70bc"
import script from "./KeepAliveView.vue?vue&type=script&lang=js"
export * from "./KeepAliveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports